import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const BookingOptionSelectionsTableActions = [
  {
    id: 'edit',
    title: 'Edit Selection',
    tooltip: 'Edit selection',
    icon: 'tabler-pencil',
    color: 'primary',
    emit: 'edit',
  },
  {
    id: 'view',
    title: 'View Selection',
    tooltip: 'View selection',
    icon: 'tabler-eye',
    color: 'primary',
    emit: 'view',
  },
] as const satisfies readonly TableActionSpec[]
